import React from "react";
import styled from "styled-components";

const StyledIcon = styled.img``;

export function Icon({ ...props }) {
  return <StyledIcon {...props} />;
}
